/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ali Zia Khan",
  title: "Hi all, I'm Ali",
  subTitle: emoji(
    "A Passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / MERN / React Native along with expertise in .NET Core and Ethereum Blockchain."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1zJYdalOq4trp4kz-SX7BPdGfnbt67F-V/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github:   "https://github.com/ALI-ZIA-KHAN",
  linkedin: "https://www.linkedin.com/in/alizk16/",
  gmail:    "aliziakhan1682@gmail.com",
  twitter:  "https://twitter.com/AliZKhan17",
  facebook: "https://www.facebook.com/heroism92",
  hashnode: "https://aliverse.hashnode.dev/",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Tools I Use To Do Magic On Web",
  // subTitle: "Passionate Software Developer who wants to deliver the best work.",
  skills: [
    // emoji(
    //   "✨ Develop Full Stack Web Applications utilizing the MERN Stack/Next.js/Typescript"
    // ),
    // emoji(
    //   "📱 Devise professional Mobile Applications with React Native."
    // ),
    // emoji(
    //   "🚀 Engineer comprehensive Frontend Designs, Scalable Backends, and Robust Databases."
    // ),
    // emoji(
    //   "- 🌐 Formulate and implement Decentralized Applications within the Ethereum Ecosystem."
    // ),
    // emoji(
    //   "🔗 Integration of Third-Party Services in a seamless manner."
    // )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "next.js",
      fontAwesomeClassname: "fab fa-neos"
      // fontAwesomeClassname: <FaNe
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "typescript",
      fontAwesomeClassname: "fab fa-tumblr"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongo",
      fontAwesomeClassname: "fab fa-maxcdn"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "dotnet",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-atlassian"
    },
    {
      skillName: "web3",
      fontAwesomeClassname: "fab fa-ethereum"
    },
    {
      skillName: "react-native",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-github"
    }
   
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "NED University of Engineering and Technology Karachi",
      logo: require("./assets/images/NEDUET_logo.png"),
      subHeader: "Bachelor of Engineering in Software Engineering",
      duration: "October 2019 - October 2023",
      desc: "PEC and Washington Accord Accredited Engineer.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "CAA Model Schools and Collegr",
      logo: require("./assets/images/CAA_Logo.png"),
      subHeader: "Matriculation Computer Science",
      duration: " 2007 -  2017",
      desc: "Gold Medalist in Matriculation Examinations in Karachi",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Full Stack Web Apps (MERN/ Next.js/ TypeScript / .NET Core)", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Mobile Applications (React Native)",
      progressPercentage: "90%"
    },
    {
      Stack: "Decentralized Applications (Ethereum Ecosystem)",
      progressPercentage: "70%"
    },
    {
      Stack: "Database Designing (SQL/NoSQL)" ,
      progressPercentage: "80%"
    },
    {
      Stack: "Integration of Third-Party Services and APIs.",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Techlogix",
      companylogo: require("./assets/images/techlogix.png"),
      date: "October 2023 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Software Engineer",
      company: "HashPotato",
      companylogo: require("./assets/images/hashpotato.png"),
      date: "October 2021 – August-2023",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Developer Virtual Experience Intern",
      company: "Accenture",
      companylogo: require("./assets/images/Accenture_logo.png"),
      date: "September 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Virtual Solutions Architect Intern",
      company: "AWS-Forage",
      companylogo: require("./assets/images/AWS.png"),
      date: "January 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Web Application Projects",
  subtitle: "Some awesome projects that I have worked or working on!",
  projects: [
    {
      image: require("./assets/images/kharcha.png" ),
      projectName: "Kharcha",
      projectDesc: "Kharcha is an expense tracker application that helps you to keep track of your daily expenses.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mykharcha.co/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/metaverse2.png"),
      projectName: "Metaverse Madness",
      projectDesc: "A diversely featured web application developed in context with modern and sleek designing architecture",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://main--silly-quokka-d86004.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/ECOM.PNG"),
      projectName: "One Stop Shop",
      projectDesc: "A minimalistice yet comprehensive E-Commerce Site",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://allstuffcorner.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Buggati.PNG"),
      projectName: "Buggati",
      projectDesc: "Sleek Web Interface designed for NFT influenced Cars Platform",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bugatti-98fc2.web.app/"
        }
      ]
    },
    
    {
      image: require("./assets/images/car.PNG"),
      projectName: "Pizzaerio Travels",
      projectDesc: "An alluring online presence developed for a potential Travel Client",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://pizzerio-travels.web.app/"
        }
      ]
    },
    {
      image: require("./assets/images/food.png"),
      projectName: "Gericht",
      projectDesc: "An enriching restaurant website filled with tastes and flavors of cuisine in a unique way",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://main--resonant-meringue-f55aa2.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Sheltos.PNG"),
      projectName: "Your Home Finder",
      projectDesc: "A Real Estate Web Application in progress that helps you to find your dream home",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://real-estate-experience-redifined.vercel.app/"
        }
      ]
    }
    

  ],
  display: true // Set false to hide this section, defaults to true
};







//Mobile Projects

const mobileProjects = {
  title: "Mobile Application Projects",
  subtitle: "Some awesome projects that I have worked or working on! ",
  projects: [
    {
      image: require("./assets/images/MobileApp1.jpeg" ),
      projectName: "Traveler's App",
      projectDesc: "An full stack application that is part of large project comprising of features like live-location tracking, payment integration, and much more. and chat",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://mykharcha.co/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/MobileApp2.png"),
      projectName: "Dr. Plant",
      projectDesc: "Plant Disease Detector application that can detect if plant is healthy or not and shows disease name upon leaf image whose backend is integrated with Deep Learnig Model and Flask",

      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://main--silly-quokka-d86004.netlify.app/"
      //   }
      // ]
    },
    {
      image: require("./assets/images/MobileApp3.PNG"),
      projectName: "Kharcha App",
      projectDesc: "Kharcha is an expense tracker application that is quite easy-to-use and handy to keep track of your daily expenses.",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://allstuffcorner.netlify.app/"
      //   }
      // ]
    },
    {
      image: require("./assets/images/MobileApp4.jpeg"),
      projectName: "KUSA Application",
      projectDesc: "An Outrighteous Social Media app that comprises of go-to features of Facebook, Instagram and Whatsapp in a single space",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://pizzerio-travels.web.app/"
      //   }
      // ]
    },
    {
      image: require("./assets/images/MobileApp5.jpeg"),
      projectName: "Mufeed",
      projectDesc: "Consolidated E-Learning Platform for both Students and Teachers much like Coursera",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://main--resonant-meringue-f55aa2.netlify.app/"
      //   }
      // ]
    }


  ],
  display: true // Set false to hide this section, defaults to true
};




//.NET Projects


const DotNETProjects = {
  title: ".NET Projects",
  subtitle: "Some awesome projects that I have worked or working on! ",
  projects: [
    {
      image: require("./assets/images/Desktop1.jpeg" ),
      projectName: "Sellerless Nursery Management System",
      projectDesc: "Barcode based Nursery Management System that automates the process where buyers can search and buy Plants without any requirement of intervening of sellers",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://mykharcha.co/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/Desktop2.jpeg"),
      projectName: "Sabri Autos",
      projectDesc: "A Complete ERP based SAS-solution developed corresponding to the requirements of Auto WholeSeller and Retailer of local market in Karachi ",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://main--silly-quokka-d86004.netlify.app/"
      //   }
      // ]
    }
    // {
    //   image: require("./assets/images/ECOM.PNG"),
    //   projectName: "One Stop Shop",
    //   projectDesc: "A minimalistice yet comprehensive E-Commerce Site",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://allstuffcorner.netlify.app/"
    //     }
    //   ]
    // },
    // {
    //   image: require("./assets/images/car.PNG"),
    //   projectName: "Pizzaerio Travels",
    //   projectDesc: "An alluring online presence developed for a potential Travel Client",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://pizzerio-travels.web.app/"
    //     }
    //   ]
    // },
    // {
    //   image: require("./assets/images/food.png"),
    //   projectName: "Gericht",
    //   projectDesc: "An enriching restaurant website filled with tastes and flavors of cuisine in a unique way",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://main--resonant-meringue-f55aa2.netlify.app/"
    //     }
    //   ]
    // }


  ],
  display: true // Set false to hide this section, defaults to true
};




//Web3 Projects


const web3Projects = {
  title: "Web3 Projects",
  subtitle: "Some awesome projects that I have worked or working on!",
  projects: [
    {
      image: require("./assets/images/Web31.PNG" ),
      projectName: "Artizyou",
      projectDesc: "Blockchain based decentralised Web Application where Certificate Generation and Verifications is aligned in the form of NFTs.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://artizyou.web.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/web32.PNG"),
      projectName: "BlockChat",
      projectDesc: "Decentralised P2P Messaging Platform where users can leverage with secure and transparent communication medium",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "https://main--silly-quokka-d86004.netlify.app/"
      //   }
      // ]
    },
    {
      image: require("./assets/images/web33.PNG"),
      projectName: "Buy Me A Coffee",
      projectDesc: "Simple Decentralized Application to give Buy-Me-A-Coffee invite with customised message",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/ALI-ZIA-KHAN/Buy-Me-A-Cofee-DApp"
        }
      ]
    }


  ],
  display: true // Set false to hide this section, defaults to true
};



// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "FYDP Selection by NGIRI & NEDAASC",
      subtitle:
        "Final Year Project was selected by National Grassroots ICT Research Initiative (NGIRI) and NEDAASC for funding examining the potential idea and its impact on the society.",
      image: require("./assets/images/ngiri.webp"),
      imageAlt: "NGIRI & NEDAASC Logo",
      // footerLink: [
      //   {
      //     name: "Certification",
      //     url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
      //   },
      //   {
      //     name: "Award Letter",
      //     url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
      //   },
      //   {
      //     name: "Google Code-in Blog",
      //     url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
      //   }
      // ]
    },
    {
      title: "Selection as per merit of Science Talent",
      subtitle:
        "Selected among 30 students as a Science Talent all over Pakistan for Science Talent Farming Scheme (STFS) by Pakistan Science Foundation (PSF)",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      // footerLink: [
      //   {
      //     name: "View Google Assistant Action",
      //     url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
      //   }
      // ]
    },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: true, // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://aliverse.hashnode.dev/security-fundamentals-in-blockchain",
      title: "Security Fundamentals in Blockchain",
      description:
        "All the security fundamentals that you need to know before diving into the world of Blockchain."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3102606951",
  email_address: "aliziakhan1682@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "AliZKhan17", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  mobileProjects,
  DotNETProjects,
  web3Projects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
